/* global axios */
import ApiClient from './ApiClient';

class CrmAutomationsAPI extends ApiClient {
  constructor() {
    super('crm/automations', { accountScoped: true });
  }

  toggle(id) {
    return axios.patch(`${this.url}/${id}/toggle`);
  }
}

export default new CrmAutomationsAPI();
